import React from "react"
import DocsLink from "components/DocsLink"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { SubscriptionType } from "sharedTypes"
import { BADGE_PRINTING_ARTICLE_URL } from "utilities/externalLinks"

const BadgeUpgradeAlert = () => (
  <UpgradeAlert
    title="Badge Printing requires a Corporate Plan or higher"
    text={(
      <>
        You can design badges here, but an upgrade is required to download
        or print them in the mobile app.
        <DocsLink url={BADGE_PRINTING_ARTICLE_URL} display="block" mt={2}>
          Learn more about Diobox Badge Printing
        </DocsLink>
      </>
    )}
    defaultSelectedPlan={SubscriptionType.Corporate}
  />
)

export default BadgeUpgradeAlert
